import { createAction, props } from '@ngrx/store';
import { HistoricalValue } from '../../types/historical-value';

export const loadHistoricalValuesFromBackend = createAction(
    '[Forms] Load historical values from Backend',
    props<{
        uniqueId: string;
    }>(),
);

export const loadHistoricalValuesFromBackendSuccess = createAction(
    '[Forms] Load historical values from Backend success',
    props<{
        historicalValues: HistoricalValue[];
    }>(),
);
